import EmptyContainer from "./EmptyContainer";

import NoResultsIcon from "../icons/NoResultsIcon";

const EmptyMasks = () => {
  return (
    <EmptyContainer
      title="Cap màscara trobada"
      description="No s'ha trobat cap màscara en el document."
      image={<NoResultsIcon />}
    />
  );
};
export default EmptyMasks;
